import type {
  FileResponse,
  GetListRequestV2,
  GetListResponseOfSelectOption,
  GetListResponseOfVendorSimpleResponse,
  GetVendorListRequest,
  VendorRequest,
  VendorResponse,
} from 'src/api/ProactApiClient';
import {vendorApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

export const vendorApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getVendorSelectOptions: builder.query<
      GetListResponseOfSelectOption,
      GetVendorListRequest
    >({
      queryFn: clientQuery(params => vendorApiClient.listSelectOptions(params)),
      providesTags: ['Vendors'],
    }),
    getVendorList: builder.query<
      GetListResponseOfVendorSimpleResponse,
      GetVendorListRequest
    >({
      queryFn: clientQuery(params => vendorApiClient.list(params)),
      providesTags: ['Vendors'],
    }),
    getVendorListV2: builder.query<
      GetListResponseOfVendorSimpleResponse,
      GetListRequestV2
    >({
      queryFn: clientQuery(params => vendorApiClient.listV2(params)),
      providesTags: ['Vendors'],
    }),
    getVendor: builder.query<VendorResponse, number>({
      queryFn: clientQuery(id => vendorApiClient.get(id)),
      providesTags: ['Vendors'],
    }),
    createVendor: builder.mutation<VendorResponse, VendorRequest>({
      queryFn: clientQuery(request => vendorApiClient.create(request)),
      invalidatesTags: ['Vendors'],
    }),
    updateVendor: builder.mutation<VendorResponse, VendorRequest>({
      queryFn: clientQuery(request => vendorApiClient.update(request)),
      invalidatesTags: ['Vendors'],
    }),
    deleteVendor: builder.mutation<boolean, number>({
      queryFn: clientQuery(id => vendorApiClient.delete(id)),
      invalidatesTags: ['Vendors'],
    }),
    exportVendors: builder.mutation<FileResponse | null, void>({
      queryFn: clientQuery(() => vendorApiClient.export()),
    }),
    updateVendorActiveStatus: builder.mutation<
      VendorResponse,
      {id: number; active: boolean}
    >({
      queryFn: clientQuery(({id, active}) =>
        vendorApiClient.updateActiveStatus(id, active)
      ),
      invalidatesTags: ['Vendors'],
    }),
  }),
});

export const {
  useGetVendorListQuery,
  useGetVendorSelectOptionsQuery,
  useGetVendorListV2Query,
  useGetVendorQuery,
  useCreateVendorMutation,
  useUpdateVendorMutation,
  useDeleteVendorMutation,
  useUpdateVendorActiveStatusMutation,
  useExportVendorsMutation,
} = vendorApi;
